import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../utils/enums';
import { useAPI } from '@pella/cosmos-react';

/**
 * Hook to fetch distribution account data for a given cost center.
 * @param {string} costCenter - The cost center code to fetch distribution for.
 * @returns {object} Distribution account query result with data, error, success, loading, fetched, and error states.
 */
export const useDistAcctByCC = (costCenter) => {
  const { api, apiReady } = useAPI();

  const fetchDistribution = async () => {
    const results = await api.invMgmt.getCostCenterDistribution(costCenter);
    if (!results) throw new Error(`No Distributions found for Cost Center: ${costCenter}`);
    return results;
  };

  const { data, error, isSuccess, isLoading, isFetched, isError } = useQuery({
    queryKey: [QUERY_KEYS.MOVE_ORDER_DIST_ACCT_BY_CC, costCenter],
    queryFn: fetchDistribution,
    enabled: apiReady && Boolean(costCenter),
    staleTime: Number.POSITIVE_INFINITY,
  });

  return { data, error, isSuccess, isLoading, isFetched, isError };
};
